import CustomButton from "../CustomButton/Button";
import { Typography, Image } from "antd";
import FbIcon from "../../assets/icons/fb.svg";
import twitterIcon from "../../assets/icons/twitter.svg";
import LinkedinIcon from "../../assets/icons/linkedin.svg";
import { BTN_TXT, SOCIAL_MEDIA_LINKS } from "../../constants/constants";
import { useNavigate } from "react-router-dom";
import TermsPdf from "../../assets/docs/TermsAndConditions.pdf";
import PrivacyPdf from "../../assets/docs/PrivacyPolicies.pdf";
import RefundPdf from "../../assets/docs/RefundPolicies.pdf";
import "./Footer.scss";

const Footer = () => {
    const currentYear = new Date().getFullYear();
    const navigate = useNavigate();

    // Function to open links in a new tab
    const openLink = (url) => {
        window.open(url, "_blank", "noopener,noreferrer");
    };

    const viewFooterLinks = (title, path, pdfPath) => {
        navigate(`/view-pdf/${path}`, {
            state: {
                title,
                pdfPath
            }
        });
    }

    return (
        <div className="footer-container">
            {/* Footer Left - Copyright */}
            <Typography className="copyright-text">
                Karncy © {currentYear}, All Rights Reserved
            </Typography>

            {/* Footer Center - Links */}
            <div className="footer-link-group">
                <CustomButton
                    type="text"
                    className="footer-link"
                    onClick={() => navigate("/support")}
                >
                    {BTN_TXT.SUP_FAQ}
                </CustomButton>
                <Typography>●</Typography>
                <CustomButton
                    type="text"
                    className="footer-link"
                    onClick={() => viewFooterLinks(BTN_TXT.PRI_POL, 'privacy-policy', PrivacyPdf)}
                >
                    {BTN_TXT.PRI_POL}
                </CustomButton>
                <Typography>●</Typography>
                <CustomButton
                    type="text"
                    className="footer-link"
                    onClick={() => viewFooterLinks(BTN_TXT.TERM_COND, 'terms-conditions', TermsPdf)}
                >
                    {BTN_TXT.TERM_COND}
                </CustomButton>
                <Typography>●</Typography>
                <CustomButton
                    type="text"
                    className="footer-link"
                    onClick={() => viewFooterLinks(BTN_TXT.REFUND_POL, 'refund-policy', RefundPdf)}
                >
                    {BTN_TXT.REFUND_POL}
                </CustomButton>
            </div>

            {/* Footer Right - Social Icons */}
            <div className="social-icons">
                <CustomButton
                    type="text"
                    style={{ padding: 0 }}
                    icon={<Image preview={false} src={FbIcon} alt="Facebook" />}
                    onClick={() => openLink(SOCIAL_MEDIA_LINKS.FB)}
                />
                <CustomButton
                    type="text"
                    style={{ padding: 0 }}
                    icon={<Image preview={false} src={twitterIcon} alt="Twitter" />}
                    onClick={() => openLink(SOCIAL_MEDIA_LINKS.X)}
                />
                <CustomButton
                    type="text"
                    style={{ padding: 0 }}
                    icon={<Image preview={false} src={LinkedinIcon} alt="LinkedIn" />}
                    onClick={() => openLink(SOCIAL_MEDIA_LINKS.LI)}
                />
            </div>
        </div>
    );
};

export default Footer;
